type NotificationMessageItem = {
    notificationState:NotificationState,
    notificationType:NotificationType,
    summary:string,
    textBody:string,
    htmlBody:string,
    isHtmlPreferred:boolean
}

/**
 * 通知状态
 * @param Wait 等待结果
 * @param Success 成功
 * @param Info 信息
 * @param Warn 警告
 * @param Error 异常失败
 */
enum NotificationState {
    /**
     * 等待结果
     */
    Wait,
    /**
     * 成功
     */
    Success,
    /**
     * 信息
     */
    Info,
    /**
     * 警告
     */
    Warn,
    /**
     * 异常失败
     */
    Error
}
/**
 * 通知类型
 * @param None 无类型
 * @param Excel 导出Excel
 * @param Sign 签名
 * @param Update 更新
 */
enum NotificationType {
    /**
     * 无类型
     */
    None,
    /**
     * 导出Excel
     */
    Excel,
    /**
     * 签名
     */
    Sign,
    /**
     * 更新
     */
    Update
}


type NotificationItem = {
    Read:boolean,
    CreatedUtc:Date,
    MessageId:string,
    Message:string,
    Body:string,
    IsHtmlBody:boolean,
    ToDo:string,
    ShowToDo:boolean,
    WorkflowId:string
}

export{
    NotificationMessageItem,
    NotificationState,
    NotificationType,
    NotificationItem
}